export const loadNewPipelineVersionPage = (pipelineHistoryResponse, history) => {
  const newVersion = pipelineHistoryResponse?.data?.pipeline_version[0].version;
  const createNewPathArr = history.location.pathname.split('/');
  createNewPathArr[createNewPathArr.length - 1] = newVersion;
  history.push(createNewPathArr.join('/'))
}
